export default __webpack_public_path__ + "static/media/ephemeral_2.3cf1512c.png";